import { render, staticRenderFns } from "./PastProjects.vue?vue&type=template&id=d10ea16e&scoped=true&"
import script from "./PastProjects.vue?vue&type=script&lang=js&"
export * from "./PastProjects.vue?vue&type=script&lang=js&"
import style0 from "./PastProjects.vue?vue&type=style&index=0&id=d10ea16e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10ea16e",
  null
  
)

export default component.exports